import { createAction } from 'redux-actions';

export const restoreViewState = createAction('RESTORE_VIEW_STATE');



// WEBPACK FOOTER //
// ./src/shared/actions/view/index.js